import { EventType, MatrixEvent } from 'matrix-js-sdk/src';

import { CustomMeedioMatrixEvents } from 'utils/matrixUtils';

import {
  PIXEL_THRESHOLD_VALUE_FOR_ATTACHMENT_SCROLL,
  PIXEL_THRESHOLD_VALUE_FOR_SCROLL,
  TEXT_AREA_VERTICAL_PADDING,
  textAreaConstants,
} from './chatConstants';

export type MessageRecipient = {
  displayName: string;
  matrixUserId: string;
  deviceId: string;
};
export interface ChatFormInputs {
  message: string;
  files: File[];
  recipient: MessageRecipient | null;
}

export const removeDuplicateFiles = (files: File[], prop: keyof File) => [
  ...new Map(files.map((file) => [file[prop], file])).values(),
];

export const calculateRows = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
  const previousRows = event.target.rows;
  event.target.rows = textAreaConstants.MIN_MESSAGE_ROWS;

  const currentRows = ~~(
    (event.target.scrollHeight - TEXT_AREA_VERTICAL_PADDING / previousRows) /
    textAreaConstants.TEXTAREA_LINE_HEIGHT
  );

  if (currentRows === previousRows) event.target.rows = currentRows;
  if (currentRows >= textAreaConstants.MAX_MESSAGE_ROWS) {
    event.target.rows = textAreaConstants.MAX_MESSAGE_ROWS;
    event.target.scrollTop = event.target.scrollHeight;
  }

  return currentRows < textAreaConstants.MAX_MESSAGE_ROWS ? currentRows : textAreaConstants.MAX_MESSAGE_ROWS;
};

export const getIsAllowedEventType = (eventType: string) =>
  [EventType.RoomMessage, EventType.RoomMessageEncrypted].includes(eventType as EventType) ||
  eventType === CustomMeedioMatrixEvents.SCHEDULED_MEETING ||
  eventType === CustomMeedioMatrixEvents.MEETING_STARTED;

export const getIsEligibleToScroll = (messagesContainer: HTMLDivElement, isAttachment = false) => {
  const { scrollHeight, scrollTop, clientHeight } = messagesContainer;

  const threshold = isAttachment ? PIXEL_THRESHOLD_VALUE_FOR_ATTACHMENT_SCROLL : PIXEL_THRESHOLD_VALUE_FOR_SCROLL;

  return scrollHeight - scrollTop - clientHeight <= threshold;
};

export const sortMatrixEventsByTime = (events: MatrixEvent[]) =>
  events.sort((a, b) => {
    if (a.localTimestamp < b.localTimestamp) return -1;
    return a.localTimestamp > b.localTimestamp ? 1 : 0;
  });
